import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomerForm from './CustomerForm';
import useObjectTabCustomer from './model/useObjectTabCustomer';

const ObjectTabCustomer = () => {
    const { t } = useTranslation(['Objects']);
    const {
        formValues,
        readOnly,
        isSaving,
        isYcBusy,
        isAiBusy,
        isDecliningName,
        handleDeclineRepresentativeName,
        ycCodeReady,
        yesLabel,
        noLabel,
        getPersonTypeLabel,
        handleChange,
        handleFetchYouControl,
        handleSave,
        refInputFile,
        uploadProgress,
        aiPhase,
        processingLabel,
        handleOpenClick,
        handleChangeFile,
        handleCancel,
        catalog,
        selectedCatalogId,
        showCatalogSelect,
        handleSelectCatalog,
        customerFiles,
        clientCustomerId,
        handleCustomerFilesChange,
        handleEnsureCustomerForFiles,
    } = useObjectTabCustomer();

    const catalogSelect = showCatalogSelect ? (
        <Form.Group className="mb-3">
            <label className="form-label text-muted">{t('customer.catalogSelect')}</label>
            <Form.Select
                value={selectedCatalogId}
                onChange={(e) => handleSelectCatalog(e.target.value)}
            >
                <option value="">{t('customer.catalogPlaceholder')}</option>
                {catalog.map((row) => (
                    <option key={row.ID} value={row.ID}>
                        {row.fullName || '-'}
                        {row.edrpouOrIpn ? ` (${row.edrpouOrIpn})` : ''}
                    </option>
                ))}
            </Form.Select>
        </Form.Group>
    ) : null;

    return (
        <CustomerForm
            formValues={formValues}
            readOnly={readOnly}
            isSaving={isSaving}
            isYcBusy={isYcBusy}
            isAiBusy={isAiBusy}
            isDecliningName={isDecliningName}
            handleDeclineRepresentativeName={handleDeclineRepresentativeName}
            ycCodeReady={ycCodeReady}
            yesLabel={yesLabel}
            noLabel={noLabel}
            getPersonTypeLabel={getPersonTypeLabel}
            handleChange={handleChange}
            handleFetchYouControl={handleFetchYouControl}
            handleSave={handleSave}
            refInputFile={refInputFile}
            uploadProgress={uploadProgress}
            aiPhase={aiPhase}
            processingLabel={processingLabel}
            handleOpenClick={handleOpenClick}
            handleChangeFile={handleChangeFile}
            handleCancel={handleCancel}
            headerSlot={catalogSelect}
            customerFiles={customerFiles}
            clientCustomerId={clientCustomerId}
            canEditFiles={!readOnly}
            onCustomerFilesChange={handleCustomerFilesChange}
            onEnsureCustomerForFiles={handleEnsureCustomerForFiles}
        />
    );
};

export default ObjectTabCustomer;
